export function buildExportFilterRows(dataset, entries = []) {
  const rows = [
    { filter: "Dataset", value: dataset },
    { filter: "Exported At", value: new Date().toLocaleString("en-GB") },
  ];

  (entries || []).forEach((entry) => {
    const label = String(entry?.label || "").trim();
    if (!label) return;

    if (Array.isArray(entry.value)) {
      const values = entry.value
        .map((value) => String(value ?? "").trim())
        .filter(Boolean);

      values.forEach((value) => {
        rows.push({ filter: label, value });
      });
      return;
    }

    const value = String(entry?.value ?? "").trim();
    if (!value) return;
    rows.push({ filter: label, value });
  });

  if (rows.length === 2) {
    rows.push({ filter: "Filters", value: "No filters applied" });
  }

  return rows;
}
